
/**
 * Validates if a string is a valid UUID format
 * @param uuid The string to validate
 * @returns boolean indicating if the string is a valid UUID
 */
export function isValidUUID(uuid: string) {
  if (!uuid) return false;
  
  // First, check if it's a string
  if (typeof uuid !== 'string') return false;
  
  // Validate UUID hex format without enforcing RFC 4122 version/variant bits,
  // since seeded IDs in the database may not follow those conventions
  const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  
  return regex.test(uuid);
}
